<template>
    <ul id="list-tasks">
      <li>

        <!--pc view-->
        <div id='oblea' v-show="item.tipoOblea == 1 && !mobileView">
          <div id='s1'>
            <img :src="imagenProducto" style="width: 90%; height: 90%; object-fit: contain"/> 
          </div> 
          <div id='s2'>
            <span id='titulo'>{{nombre}}</span>
          </div> 
          <div id='s22'>
            <div>
              <span class='label'>Precio:</span> 
              <span class='value'>${{item.Precio | formatMoney}}</span>
            </div>
            <div>
              <span class='label'>Cantidad:</span>
              <span id='cantidad'>{{item.Cantidad}}</span>
            </div>
          </div> 
          <div class="fh rc" style="width: 15%;  height: 100%">
            <span class='label'>Subtotal:</span>
          </div> 
          <div class="fh rc" style="width: 20%;  height: 100%">
            <span class='value'  style="margin-right: 5px" >${{(item.Precio)*item.Cantidad | formatMoney}}</span>
          </div> 
        </div>

        <div id='oblea-desc' v-show="item.tipoOblea == 2 && !mobileView" >
          <div id='s1'>
          </div> 
          <div id='s2'>
            <span id='titulo'>{{item.ProductoNombre}}</span>
          </div> 
          <div class="fh lc" style="width: 24%; height: 100%; padding-left: 10px">
              <div class="fh lc" style="font-size: 12px; color: #656E76">
                   Descuento:
              </div> 
              <div class="fh lc" style="font-size: 12px; color: #656E76; margin-left: 5px">
                   ${{item.Precio | formatMoney}}
              </div>
          </div> 
          <div id='s3'>
          </div> 
          <div id='s4'>
          </div> 
        </div>

        <!--mobile view-->
        <div v-show="item.tipoOblea == 1  && mobileView" class="fv ct" style="width:90vw; border-style: solid;border-width: 1px; border-color: #dddddd; border-radius: 10px;  box-shadow: 2px 2px 4px #dddddd; -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow:2px 2px 4px #dddddd;  margin-bottom: 20px">
            <div class="fh cc" style="width:100%; height:140px;">
                <div class="fv cc" style="width:40%; height:100%;" >
                    <img style="width: 80%" :src="imagenProducto"/>
                </div>
                <div class="fv cc" style="width:60%; height:100%;" >
                    <div class="fh lc" style="font-size: 14px; font-weight: 800; color: #5C666F"> {{nombre}} </div>
                    <div class="fh lc" style="font-size: 12px; font-weight: 500; margin-top: 15px; color: #5C666F"> Precio: ${{item.Precio | formatMoney}}</div>
                    <div class="fh lc" style="font-size: 12px; font-weight: 500; margin-top: 5px; color: #5C666F"> Cantidad: {{item.Cantidad}}</div>
                    <div class="fh lc" style="font-size: 13px; font-weight: 500; margin-top: 10px; color: #5C666F"> Subtotal: ${{(item.Precio)*item.Cantidad | formatMoney}}</div>
                </div>
            </div>
        </div>

        <div class="fh lc" v-show="item.tipoOblea == 2 && mobileView" style="width: 90vw; height:30px; margin-top: 10px; margin-bottom: 5px; background-color: #ffffaa; border-style: solid; border-width: 1px; border-color:#dddddd; border-radius: 10px; box-shadow: 1px 1px 3px #dddddd;">
          <div class="fh lc" style="width: 55%; margin-left: 20px">
            <div class="fh lc" style="font-size: 13px; color: #656E76; font-weight: 500;">{{item.ProductoNombre}}</div>
          </div> 
          <div class="fh lc" style="width: 45%;">
            <div class="fh lc" style="font-size: 12px; color: #656E76; font-weight: 500">Desc:</div> 
            <div class="fh lc" style="font-size: 12px; color: #656E76; font-weight: 500"> $ {{item.Precio | formatMoney}}</div>
          </div> 
        </div>

      </li>
    </ul>
</template>
  



   
  <script>
  import axios from 'axios'


    export default {
      name: 'item-pedidoCms',
      props: ['item'],

      data()  {
        return {
          //imagenProducto: null,
          mobileView:false  
        }
      },


      watch: {
        item: {
          immediate: true,
          handler  () {
            //this.getImage()
          }
        }
      },


      computed: {
        nombre(){
          if (this.item.ProductoNombre.length > 1)
          {
            return this.item.ProductoNombre
          }
          else
          {
            return this.item.PromocionNombre
          }
        },

        imagenProducto() {
          if (this.item.UrlImagen != null) {
            return this.item.UrlImagen
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        },

      },


      methods: {
        
        onResize() {
            if (window.innerWidth > 600) 
            {
            this.mobileView=false;
            }
            else 
            {
            this.mobileView=true;
            }
        },
     

        downloadImage (imagenId) {
          let config = { method: 'GET',
                         responseType: 'blob',
                         url:'/WebSalesArchivo?ArchivoId='+imagenId+'&Ancho=150',
                         headers: {
                            Token:        this.$store.state.user.usuario.Token,
                            ClientSecret: this.$store.state.entorno.clientSecret,
                            EmpresaId:    this.$store.state.entorno.idEmpresa
                         }
                       }
                  axios
                  .request(config)
                  .then(response => {
                    let reader = new FileReader()
                    reader.onload = () => {
                      this.imagenProducto = reader.result
                      var img = {id:imagenId,image:this.imagenProducto} 
                      this.$store.commit('pedido/saveImage',img)   
                    }
                    reader.readAsDataURL(response.data)
                  })
                  .catch(err =>{
                    this.imagenProducto = '/dist/placeholder-producto.png'
                    console.log(err)
                  })
        },


        getImage () {
          this.imagenProducto = '/dist/placeholder-producto.png'
          if (this.item.ProductoId != 0 )
          {
            var producto = this.$store.state.pedido.productos.find(elem => elem.Id === this.item.ProductoId)
            if (producto != null)
            {
              if (producto.ArchivoId != null)
              {
                var img = this.$store.state.pedido.imagenes.find( e => e.id === producto.ArchivoId);
                if (img != null)
                {
                  this.imagenProducto = img.image
                } 
                else
                {
                  this.downloadImage(producto.ArchivoId) 
                }
              }
            }
          }
          else if (this.item.PromocionId != 0 )
          {
            var promocion = this.$store.state.pedido.promociones.find(elem => elem.Id === this.item.PromocionId)
            if (promocion != null)
            {
              if ((promocion.ArchivosId != null) && (promocion.ArchivosId.length > 0))
              {
                var img = this.$store.state.pedido.imagenes.find( e => e.id === promocion.ArchivosId[0]);
                if (img != null)
                {
                  this.imagenProducto = img.image
                } 
                else
                {
                  this.downloadImage(promocion.ArchivosId[0]) 
                }
              }
            }
          }
        }

      },

      mounted () {
    this.onResize()
   },

   created() {
     window.addEventListener('resize', this.onResize)
   },

   beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
   }

    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 5px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  

#oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}


.label-desc{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 70px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#s1{
  width: 14%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 27%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 35%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-end;  
}

/* #s4{
  width: 8%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
} */

  

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


#cantidad{
  font-size: 12px;
  color: #656E76;
  margin-top: 3px;
  margin-bottom: 3px;
}

 
  
   </style>


// WEBPACK FOOTER //
// src/components/views/estadoPresupuesto/itemPresupuestoCms.vue